<script setup>
import {computed, onMounted, ref, watch} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useMainStore} from './store/main'
import Header from './components/Header.vue'
import OrientationLock from "./components/OrientationLock.vue";
import {useOrientationLock} from "./utils/useOrientationLock.js";
import Divider from "@/components/Divider.vue";
// import {useZendesk} from "./utils/zendesk.js";

const store = useMainStore()
const router = useRouter()
const route = useRoute()

const isInitialized = ref(false)
const isLoggedIn = computed(() => !!(store.user || sessionStorage.getItem('auth_token')))

// const { init, setVisibility } = useZendesk()
// const isLoginPage = computed(() => route.name === 'login')
//
// watch(isLoginPage, (val) => {
// 	setVisibility(val)
// }, {immediate: false})

// Restore session on app startup
onMounted(async () => {
	console.log('[APP] App starting, checking for existing session...')
	
	console.log('[APP] App starting, checking for existing session...')
	try {
		const sessionRestored = await store.restoreSession()
		
		if (sessionRestored) {
			console.log('[APP] Session restored, loading site data...')
			await store.loadSiteData(store.user.host_site_id)
			
			if (router.currentRoute.value.name === 'login') {
				await router.push('/home')
			}
		}
	} catch (err) {
		console.error('[APP] Initialization error:', err)
	} finally {
		isInitialized.value = true
	}
})

useOrientationLock()
</script>

<template>
	<OrientationLock/>
	<template v-if="isInitialized">
		<Header v-if="isLoggedIn"/>
		<router-view v-slot="{ Component }">
			<Transition name="page" mode="out-in">
				<component :is="Component"/>
			</Transition>
		</router-view>
	</template>
	
	<div v-else class="loading-container">
		<div class="loading-content">
			<img class="logo" src="/images/buzztime.svg" alt="Buzztime Remote"/>
			<p class="loading-text">Getting things ready</p>
		</div>
	</div>
</template>

<style>
@import "@/assets/styles/vars.css";
@import "@/assets/styles/transitions.css";
</style>

<style scoped>
.loading-container {
	position: fixed;
	inset: 0;
	width: 100vw;
	height: 100dvh;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999;
}

.loading-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: var(--spacing-lg);
	text-align: center;
}

.loading-content .logo {
	width: 200px;
	max-width: 60vw;
	height: auto;
	animation: loading-pulse 2s infinite ease-in-out;
}

.loading-text {
	color: var(--color-text-secondary);
	font-size: var(--font-size-base);
	font-weight: 500;
	letter-spacing: 0.03em;
	margin: 0;
}

@keyframes loading-pulse {
	0%, 100% {
		opacity: 0.6;
		transform: scale(0.97);
	}
	50% {
		opacity: 1;
		transform: scale(1);
	}
}
</style>